/*
 * Copyright © 2026 Bruce Matin,  ALL RIGHTS RESERVED!
 */

export const API_ENDPOINTS = {
  AUTH: {
    LOGIN: '/v1/auth/login',
    REGISTER: '/v1/auth/register',
  },
  ME: {
    DASHBOARD: '/v1/me/dashboard',
    ITEMS: '/v1/me/items',
    PROFILE: '/v1/me/profile',
    ADS: '/v1/me/ads',
    STRIPE_ONBOARD: '/v1/me/stripe/onboard',
  },
  ITEMS: {
    LIST: '/v1/items',
    DETAILS: (id: string | number) => `/v1/items/${id}`,
    CREATE: '/v1/items',
    UPDATE: (id: string | number) => `/v1/items/${id}`,
    DELETE: (id: string | number) => `/v1/items/${id}`,
  },
  CATEGORIES: {
    LIST: '/v1/categories',
  },
  MESSAGES: {
    LIST: '/v1/messages',
    THREAD: (id: string | number) => `/v1/messages/${id}`,
    SEND: '/v1/messages',
  },
  USERS: {
    DETAILS: (id: string | number) => `/v1/users/${id}`,
  },
  SEARCH: (query: string, lat?: number, lng?: number, radius?: number) => {
    let url = `/v1/search?q=${encodeURIComponent(query)}`;
    if (lat && lng) url += `&lat=${lat}&lng=${lng}`;
    if (radius) url += `&radius=${radius}`;
    return url;
  },
  ADS: {
    CREATE: '/v1/ads',
  },
  ADMIN: {
    USERS: '/v1/admin/users',
    BAN_USER: (id: string | number) => `/v1/admin/users/${id}/ban`,
    ITEMS: '/v1/admin/items',
    APPROVE_ITEM: (id: string | number) => `/v1/admin/items/${id}/approve`,
    SETTINGS: '/v1/admin/settings',
  }
};
